import { useMobileMenuState } from "../../../store/mobileMenu/mobileMenu.selectors";

import { useActions } from "../../../hooks/use-actions";

import { Logo } from "../../ui/Logo/Logo";
import { Languages } from "../Languages/Languages";
import { MenuButton } from "./components/MenuButton/MenuButton";
import { Navigation } from "./components/Navigation/Navigation";

import { Container } from "../Сontainer/Container.styled";
import {
  GridContainer,
  GridItem,
  GridItemOne,
  GridItemTwo,
  HeaderStyled,
} from "./Header.styled";

export const Header = () => {
  const isOpen = useMobileMenuState();
  const { setMenu } = useActions();

  if (typeof document !== "undefined") {
    document.body.style.overflow = isOpen ? "hidden" : "visible";
  }

  const toggleMenu = () => {
    setMenu(!isOpen);
  };

  return (
    <HeaderStyled isOpen={isOpen}>
      <Container>
        <GridContainer container>
          <GridItem>
            <MenuButton isOpen={isOpen} handler={toggleMenu} />
            <Logo />
          </GridItem>
          <GridItemOne size={{ xs: 12, md: "auto" }}>
            <Navigation />
          </GridItemOne>
          <GridItemTwo>
            <Languages />
          </GridItemTwo>
        </GridContainer>
      </Container>
    </HeaderStyled>
  );
};
